<template>
  <div> 
    <div class="subscriptions">
      <h1>{{ title }}</h1>
      <h2>{{ subHeading }}</h2>

      <div class="subscriptions__options">
        <template v-for="(sub, index) in subscription()"> 
          <div :key="index">
            <accordion 
              :number="(index + 1)" 
              :title="sub.heading" 
              :open="shouldOpen(sub.slug)"
              :slug="sub.slug" 
              @try-opening="tryOpening"  
            >
              <template v-if="sub.control === 'tiles'">
                <tile 
                  @tile-clicked="handleTileClick" 
                  v-for="(tile, index) in optionsForSection(sub.slug)" 
                  :key="index" 
                  :name="tile.name" 
                  :display-name="tile.displayName"
                  :image="tile.image"
                  :desc="tile.desc"
                  :selected="tile.name === wooSub[sub.slug]"
                  :purpose="sub.slug" 
                />
              </template>
              <template v-else>
                <slider :slug="sub.slug" :initial-frequency="parseInt(sub.value)" @update-frequency="updateFrequency" />
              </template>
            </accordion>
          </div>
        </template>
      </div>
      <summary-box 
        :subscription="subscription()" 
        :values="wooSub"
        :house-filter-pricing="houseFilterPricing"
        :house-espresso-pricing="houseEspressoPricing"
        :decaff-filter-pricing="decaffFilterPricing"
        :decaff-espresso-pricing="decaffEspressoPricing"
        :single-pricing="singlePricing"
        :capsule-house-pricing="capsuleHousePricing"
        :capsule-single-pricing="capsuleSinglePricing"
        :capsule-decaff-pricing="capsuleDecaffPricing"
        :shipping="shipping"
        :sub-switch="hasSubSwitch ? subSwitch : false"
      />
    </div>
    <questions :faqs="faqs" />
    <!-- <choose-sub /> -->
  </div>
</template>

<script>
import SummaryBox from './SummaryBox'
import Accordion from './Accordion'
import Tile from './Tile'
import Slider from './Slider'
import Questions from './Questions'

export default {
  data () {
    return { 
      currentSection: 'type',
      options: {
        Coffee: [
        {
          name: 'Filter', 
          desc: 'Roasted for filter brewing methods like V60, Chemex & AeroPress.',
          displayName: 'Filter',
          image: '../app/themes/cliftoncoffee/dist/images/subscriptions/filter.jpg'
        },
        {
          name: 'Espresso',
          desc: 'Roasted for espresso brewing (Wholebean only).',
          displayName: 'Espresso',
          image: '../app/themes/cliftoncoffee/dist/images/subscriptions/machine.jpg'
        }],
        'Variety Selection': [{
          name: 'Single Origin',
          desc: 'Coffee from a single farm. Seasonal, complex and vibrant.',
          displayName: 'Single Origin',
          image: '../app/themes/cliftoncoffee/dist/images/subscriptions/single.jpg'
        },
        {
          name: 'Decaf',
          desc: 'Delicious coffee, without the caffeine.',
          displayName: 'Decaf',
          image: '../app/themes/cliftoncoffee/dist/images/subscriptions/blend.jpg'
        },
        {
          name: 'House', 
          desc: 'Consistent, rich and sweet.',
          displayName: 'House',
          image: '../app/themes/cliftoncoffee/dist/images/subscriptions/house.jpg'
        }],
        'varietyCapsules': [{
          name: 'Rocky Mountain',
          desc: 'Anaerobically fermented single origin.',
          displayName: 'Rocky Mountain',
          image: '../app/themes/cliftoncoffee/dist/images/subscriptions/rockymountain.jpg'
        },
        {
          name: 'Village Espresso', 
          desc: 'Our original house espresso blend.',
          displayName: 'Village Espresso',
          image: '../app/themes/cliftoncoffee/dist/images/subscriptions/house.jpg'
        }],
        quantityBags: [{
          name: '1',
          displayName: '250G',
          image: '../app/themes/cliftoncoffee/dist/images/subscriptions/250g_bag.png'
        },
        {
          name: '2',
          displayName: '2 x 250G',
          image: '../app/themes/cliftoncoffee/dist/images/subscriptions/two250.png'
        },
        {
          name: '4',
          displayName: '1 KG',
          image: '../app/themes/cliftoncoffee/dist/images/subscriptions/1kgbag.png'
        }],
        quantityCapsules: [{
          name: '10',
          desc: '10 Capsules',
          displayName: '10',
          image: '../app/themes/cliftoncoffee/dist/images/subscriptions/capsule.jpg'
        },
        {
          name: '20',
          desc: '20 Capsules',
          displayName: '20',
          image: '../app/themes/cliftoncoffee/dist/images/subscriptions/20capsule.jpg'
        },
        {
          name: '50',
          desc: '50 Capsules',
          displayName: '50',
          image: '../app/themes/cliftoncoffee/dist/images/subscriptions/50capsule.jpg'
        }],
        Grind: [{
          name: 'Wholebean',
          desc: 'Coffee that’s not ground, perfect if you’re going to be grinding yourself.',
          displayName: 'Wholebean',
          image: '../app/themes/cliftoncoffee/dist/images/subscriptions/wholebean.jpg'
        },
        {
          name: 'Filter Grind',
          desc: 'Great for V60, Chemex and AeroPress brewing methods.',
          displayName: 'Filter Grind',
          image: '../app/themes/cliftoncoffee/dist/images/subscriptions/ground.png'
        },
        {
          name: 'Cafetière Grind',
          desc: 'Perfect for full immersion brewing i.e Cafetière/French Press and Clever Dripper.',
          displayName: 'Cafetière Grind',
          image: '../app/themes/cliftoncoffee/dist/images/subscriptions/coarse.jpg'
        }]
      },
      capsuleSubscription: [
        {
          number: '1',
          slug: 'Coffee',
          control: 'tiles',
          heading: 'How do you drink your coffee?',
          summaryHeading: 'Coffee type',
          displayValue: '-',
          value: ''
        },
        // {
        //   number: '2',
        //   slug: 'Variety Selection',
        //   control: 'tiles',
        //   heading: 'What type of coffee would you like?',
        //   summaryHeading: 'Variety Selection',
        //   displayValue: '-',
        //   value: ''
        // },
        {
          number: '3',
          slug: 'Quantity',
          control: 'tiles',
          heading: 'How much would you like?',
          summaryHeading: 'Quantity',
          displayValue: '-',
          value: ''
        },
        {
          number: '3',
          slug: 'frequency',
          control: 'range',
          heading: 'How often do you want deliveries?',
          summaryHeading: 'Frequency',
          displayValue: '-',
          value: '7',
        },
      ],
      bagSubscription: [
        {
          number: '1',
          slug: 'Coffee',
          control: 'tiles',
          heading: 'How do you drink your coffee?',
          summaryHeading: 'Coffee type',
          displayValue: '-',
          value: ''
        },
        {
          number: '2',
          slug: 'Quantity',
          control: 'tiles',
          heading: 'How much would you like?',
          summaryHeading: 'Quantity',
          displayValue: '-',
          value: ''
        },
        {
          number: '3',
          slug: 'Grind',
          control: 'tiles', 
          heading: 'How would you like us to grind your coffee?',
          summaryHeading: 'Grind Preference',
          displayValue: '-',
          value: ''
        },
        {
          number: '4',
          slug: 'frequency',
          control: 'range',
          heading: 'How often do you want deliveries?',
          summaryHeading: 'Frequency',
          displayValue: '-',
          value: '7',
        },
      ],
      wooSub: {},
    }
  },
  props: {
    faqs: {
      type: Array, 
      default: []
    },
    houseFilterPricing: {
      type: Object, 
      default: []
    },
    houseEspressoPricing: {
      type: Object,
      default: []
    },
    decaffFilterPricing: {
      type: Object, 
      default: []
    },
    decaffEspressoPricing: {
      type: Object,
      default: []
    },
    singlePricing: {
      type: Object, 
      default: []
    }, 
    capsuleHousePricing: {
      type: Object, 
      default: []
    },
    capsuleSinglePricing: {
      type: Object,
      default: []
    },
    capsuleDecaffPricing: {
      type: Object,
      default: []
    },
    shipping: {
      type: Number, 
      default: []
    },
    subSwitch: {
      type: Object, 
      default: () => {}
    },
    subHeading: {
      type: String,
      default: ''
    }
  },
  components: {
    SummaryBox,
    Accordion,
    Tile,
    Slider,
    Questions
  },
  computed: {
    title() {
      if (this.hasSubSwitch) {
        return 'Edit your subscription'
      } else {
        return 'Create your subscription'
      }
    },
    hasSubSwitch() {
      return !(this.subSwitch.constructor !== Object || Object.keys(this.subSwitch).length === 0)
    }
  },
  methods: {
    subscription () {
      if (this.wooSub.Coffee === 'Capsules') {
        return this.capsuleSubscription
      } else {
        if (this.wooSub.Coffee === 'Espresso') {
          return this.bagSubscription.filter(section => section.slug !== 'Grind')
        } else {
          return this.bagSubscription
        }
      }
    },
    optionsForSection(section) {
      if (section === 'Quantity') {
        if (this.wooSub.Coffee === 'Capsules') {
          return this.options['quantityCapsules'];
        } else {
          return this.options['quantityBags'];
        }
      }

      if (section === 'Variety Selection') {
        if (this.wooSub.Coffee === 'Capsules') {
          return this.options['varietyCapsules'];
        }
      }

      return this.options[section];
    },
    handleTileClick (data) {     
      if (this.subscription().find(e => e.slug === data.purpose)) {
        this.wooSub[data.purpose] = data.name

        this.openNextSection()
      } else {
        console.error('Invalid data received from tile', data)
      }
    },
    openNextSection () {
      const currentSectionIndex = this.subscription().findIndex(e => e.slug === this.currentSection)

      if (currentSectionIndex >= this.subscription().length) {
        // At the end of the array, probably do something... 
      } else {
        this.currentSection = this.subscription()[currentSectionIndex + 1].slug

        if (this.subscription()[currentSectionIndex + 1].control === 'range') {

        }
      }
    }, 
    tryOpening (section) {
      console.log('Trying to open', section)
      this.currentSection = section
    },
    shouldOpen (section) {
      return section === this.currentSection
    },
    updateFrequency (data) {
      this.wooSub.frequency = data.value

      // section.displayValue = `Every ${data.value} days`
    }
  },
  mounted () {
    this.currentSection = this.subscription()[0].slug

    let output = {};
    this.bagSubscription.map(({slug, value}) => output[slug] = value);
    this.wooSub = output; 
  }
}
</script>